<template functional>
  <a-sub-menu
    :key="props.menuInfo.key"
  >
    <span slot="title" v-if="parent.hasPerm(props.menuInfo)">
      <a-icon :component="props.menuInfo.icon" v-if="props.menuInfo.icon"/>
      <span>{{ props.menuInfo.title }}</span>
      <router-link :to="props.menuInfo.to" v-if="props.menuInfo.to"/>
    </span>
    <template v-for="item in props.menuInfo.children">
      <a-menu-item
        v-if="parent.hasPerm(item) && !item.children"
        :key="item.key"
      >
        <span>{{item.title}}</span>
        <router-link :to="item.to" v-if="item.to"/>
      </a-menu-item>
      <sub-menu
        v-if="parent.hasPerm(item) && item.children"
        :key="item.key"
        :menu-info="item"
      />
    </template>
  </a-sub-menu>
</template>
<script>
export default {
  props: ["menuInfo"]
};
</script>